import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = { class: "card-title align-items-start flex-column" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Entegrasyonlar", -1)
const _hoisted_4 = { class: "text-muted mt-1 fw-bold fs-7" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = { class: "card-body py-3" }
const _hoisted_7 = { class: "tab-content" }
const _hoisted_8 = {
  class: "tab-pane fade active show",
  id: "kt_table_widget_5_tab_1"
}
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-50px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-150px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-140px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-110px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-50px" })
  ])
], -1)
const _hoisted_12 = { class: "symbol symbol-45px me-2" }
const _hoisted_13 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
}
const _hoisted_14 = { class: "text-muted fw-bold d-block" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-success" }, "Aktif")
], -1)
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "svg-icon svg-icon-2" }
const _hoisted_19 = { class: "text-end" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "svg-icon svg-icon-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_CreateUpdateIntegration = _resolveComponent("CreateUpdateIntegration")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["card", _ctx.widgetClasses])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.data?.length ?? 0) + " Adet aktif entegrasyonunuz bulunuyor", 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", {
            href: "#",
            class: "btn btn-sm btn-light btn-primary me-2",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onAddNew && _ctx.onAddNew(...args)), ["prevent"])),
            id: "kt_user_follow_button"
          }, " Yeni Entegrasyon Ekle ")
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("table", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.data as Integration[]), (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("span", {
                            class: "symbol-label",
                            style: _normalizeStyle('background-color: ' + _ctx.IntegrationProduct.statusColor(
                        item as IIntegrationElement,
                        1
                      ) + ';color:white;font-size:14pt')
                          }, _toDisplayString(_ctx.IntegrationProduct.firstLetter(item as IIntegrationElement)), 5)
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("a", _hoisted_13, _toDisplayString(item.id) + " - " + _toDisplayString(_ctx.IntegrationProduct.friendlyName(item as IIntegrationElement)), 1),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(item.integrationType == 2 ? (item.credentials as
                      TrendyolCredentials).apiKey : item.credentials?.username), 1)
                      ]),
                      _hoisted_15,
                      _createElementVNode("td", _hoisted_16, [
                        _createElementVNode("button", {
                          type: "button",
                          title: "Entegrasyonu Düzenle",
                          class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary",
                          onClick: ($event: any) => {
                        _ctx.selectedIntegration.value = item;
                      },
                          "data-bs-toggle": "modal",
                          "data-bs-target": `#kt_modal_create_api_key`
                        }, [
                          _createElementVNode("span", _hoisted_18, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen052.svg" })
                          ])
                        ], 8, _hoisted_17)
                      ]),
                      _createElementVNode("td", _hoisted_19, [
                        _createElementVNode("button", {
                          type: "button",
                          title: "Entegrasyonu Sil",
                          class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary",
                          onClick: ($event: any) => (_ctx.deleteIntegration(item))
                        }, [
                          _createElementVNode("span", _hoisted_21, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen027.svg" })
                          ])
                        ], 8, _hoisted_20)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ])
    ], 2),
    _createVNode(_component_CreateUpdateIntegration, {
      selectedIntegration: _ctx.selectedIntegration.value,
      onSaved: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('need-refresh')))
    }, null, 8, ["selectedIntegration"])
  ], 64))
}